import * as Yup from "yup";
import { nameRegEx } from "./utils/schema";

export const locationSchema = {
  address: Yup.string()
    .required("Required.")
    .matches(...nameRegEx),
  group: Yup.string()
    .notRequired()
    .matches(
      /^\/?[\w\u00C0-\u024F\-_.,'():&\[\]+]+(\/[\w\u00C0-\u024F\-_.,'():&\[\]+]+)*\/?$/u,
      {
        message:
          "Only letters, numbers, and the following punctuation are allowed: -_.,'():&[]+/ (use / for group tiers)",
      },
    )
    .test(
      "max-tiers",
      "Maximum of 8 group tiers allowed",
      (v) => !v || v.replace(/^\/|\/$/g, "").split("/").length <= 8,
    )
    .test(
      "reserved-name",
      "'NONE' is a reserved name and cannot be used as a group",
      (v) => !v || v.replace(/^\/|\/$/g, "").toUpperCase() !== "NONE",
    ),
};
